export const downloadUrl = (repo, sourcePath) => {
    if (repo === '' || sourcePath === '') {
        return '';
    }
    // Prepend backend base URL for absolute path
    const { getBackendUrl } = require('../env');
    return getBackendUrl() + "/api/v1/" + repoUrlPart(repo) + "/download/" + sourcePath;
};

export const repoUrlPart = sourceRepository => {
    switch (sourceRepository) {
        case 'Filesystem':
            return 's3';
        
        default:
            return '';
    }
};



// WEBPACK FOOTER //
// ./src/helpers/downloadUrl.js